module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO7_04 (11).487da62.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO7_04 (11).mp4
// module id = 786
// module chunks = 1